import React from "react";
import "../styles/projectthumbnail.css";
import { Link } from "react-router-dom";

function ProjectThumbnail({ item }) {
  return (
    <div className="std-card">
      <Link className="" key={item.id} to={`/Projects/${item.id}`}>
        <div className="std-card-img">
          <img src={item.img} alt={item.text} />
        </div>
        <div className="std-card-body">
          <div className="card-role">{item.role}</div>
          <div className="card-title">{item.text}</div>
          <div className="card-desc">{item.subtext}</div>
          <div className="card-tags">
            {item.techstack.map((skill, i) => (
              <span key={i} className="tag">
                {skill}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default ProjectThumbnail;
